module.exports = __webpack_public_path__ + "img/4.5fa7a61f.png";